import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { Organization } from './organization';
export { Organization };
import { organizationSchema } from '@schemas/business-objects/organization';
import { OrgStructureLevelFormGroup } from './org-structure-level-form-group';
import { PositionFormArray } from './position-form-group';

export class OrganizationFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    orgStructureLevelId: SchemaFormControl;
    orgStructureLevel: OrgStructureLevelFormGroup;
    parentId: SchemaFormControl;
    parent: OrganizationFormGroup;
    children: OrganizationFormArray;
    positions: PositionFormArray;
  };

  declare value: Partial<Organization>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(organizationSchema, Organization, data, options);
  }

  get object(): Organization {
    return new Organization(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'orgStructureLevel':
        return new OrgStructureLevelFormGroup();
      case 'parent':
        return new OrganizationFormGroup();
      case 'children':
        return new OrganizationFormArray();
      case 'positions':
        return new PositionFormArray();
      default:
        return undefined;
    }
  }
}

export class OrganizationFormArray extends PersistedFormArray {
  readonly entityName = 'Organization' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(organizationSchema, Organization, options);
  }

  protected override createItemGroup() {
    return new OrganizationFormGroup();
  }

  get array(): Organization[] {
    return this.controls.map((group: OrganizationFormGroup) => group.object);
  }
}

export class OrganizationPersistedArray extends PersistedArray<Organization> {
  readonly entityName = 'Organization' as const;

  constructor(options?: PersistedArrayOptions) {
    super(Organization, options);
  }
}
